import { GetServerSidePropsBuilder } from 'src/services/ServerSideProps/GetServerSidePropsBuilder';
export { WiredOAuthError as default } from 'src/experiences/OAuth/Error/OAuthError.wired';

export const getServerSideProps = new GetServerSidePropsBuilder().build();
